<template>
  <section class="p-1">
    <v-card-title class="d-flex justify-space-between p-0 m-0">
      <div class="ps-2 headingFontsize">Funding</div>
      <div>
        <bread-crumb :bread-crumbs="['Funding']" />
      </div>
    </v-card-title>
    <v-divider class="p-0 m-0 primary--text"></v-divider>
    <div class="mt-5">
      <v-form ref="Addform" v-model="valid">
        <v-card outlined class="ms-2 me-2 mt-3">
          <v-toolbar flat dense class="my-5">
            <v-toolbar-title v-if="!updateTrigger">Funding Details</v-toolbar-title>
            <v-toolbar-title v-if="updateTrigger">Basic Details</v-toolbar-title>
          </v-toolbar>
          <v-row justify="center" class="ms-1 me-1">
            <v-col cols="12" md="4">
              <label class="required">Payout Partner</label>
              <v-autocomplete
                :items="ppOptions"
                v-model="temp_funding.payout_partner"
                outlined
                dense
                class="rounded"
                placeholder="Payout Partner"
                item-text="value"
                item-value="value"
                @change="onChangePPoptions($event)"
                :rules="FieldRequired('Payout Partner')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="required">FCY</label>
              <v-text-field
                v-model="temp_funding.coll_ccy_pay_ccy"
                outlined
                dense
                class="rounded"
                placeholder="FCY"
                :rules="FieldRequired('FCY')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required">USD Amount</label>
              <v-text-field
                v-model="temp_funding.lcy_amount"
                @input="changingValue($event)"
                outlined
                dense
                class="rounded"
                placeholder="USD Amount"
                type="number"
                hide-spin-buttons
                @keydown="filterNumberInput"
                :rules="[...Error, ...FieldNumbRequired('USD Amount')]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="ms-1 me-1" xs="6">
            <v-col cols="12" md="4">
              <label class="required">FCY Rate</label>
              <v-text-field
                v-model="temp_funding.dollar_lcy_rate"
                @input="changingValue($event)"
                outlined
                dense
                class="rounded"
                placeholder="FCY Rate"
                type="number"
                hide-spin-buttons
                @keydown="filterNumberInput"
                :rules="FieldNumbRequired('FCY Rate')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="">FCY Converted Amount</label>
              <v-text-field
                v-model="temp_funding.pp_amount"
                outlined
                dense
                class="rounded"
                placeholder="FCY"
                disabled
                type="number"
                hide-spin-buttons
                @keydown="filterNumberInput"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <label class="required"> Reference Number</label>
              <v-text-field
                required
                outlined
                dense
                class="rounded"
                placeholder="Reference Number"
                v-model="temp_funding.funding_number"
                @input="CheckValidity()"
                :rules="[...FundNum, ...FieldRequired('Reference Number')]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="4">
              <label class="required">Purchase Date</label>
              <v-text-field
                type="date"
                v-model="temp_funding.fund_date"
                outlined
                dense
                disabled
                class="rounded"
                placeholder="Purchase Date"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" v-if="this.updateTrigger">
              <label>Cost Rate</label>
              <v-text-field
                v-model="temp_funding.parent_lcy_rate"
                outlined
                class="rounded"
                placeholder="Cost Rate"
                dense
                disabled
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label>Partner POC</label>
              <v-text-field
                v-model="temp_funding.bank_poc"
                outlined
                class="rounded"
                placeholder="Partner"
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="12">
              <label>Remarks</label>
              <v-textarea
                outlined
                v-model="temp_funding.remarks"
                rows="3"
                max-rows="6"
                class="rounded"
                :disabled="temp_funding.fund_id"
                placeholder="Remarks"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-toolbar flat dense class="my-5" v-if="updateTrigger">
            <v-toolbar-title>Audit Details</v-toolbar-title>
          </v-toolbar>

          <v-row class="ms-1 me-1" v-if="updateTrigger">
            <v-col cols="12" md="6">
              <label>Created By</label>
              <v-text-field
                v-model="temp_funding.created_by"
                disabled
                outlined
                dense
                class="rounded"
                placeholder="Created By"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label> Created Date</label>
              <v-text-field
                type="date"
                outlined
                dense
                class="rounded"
                placeholder="Created Date"
                v-model="temp_funding.created_date"
                disabled
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label>Updated By</label>
              <v-text-field
                v-model="temp_funding.modified_by"
                disabled
                outlined
                class="rounded"
                placeholder="Updated By"
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <label> Updated Date</label>
              <v-text-field
                type="date"
                outlined
                class="rounded"
                placeholder="Updated Date"
                dense
                v-model="temp_funding.modified_date"
                disabled
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-btn
              depressed
              small
              color="primary"
              class="mb-15 me-7 text-capitalize"
              v-on:click="onSubmitFor()"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon
              >{{ updateTrigger ? "Update" : "Submit" }}
            </v-btn>
          </v-row>
        </v-card>
      </v-form>
    </div>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
// import { mapGetters } from "vuex";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
import commonService from "@/services/CommonService/commonService.js";
import { FieldRequired ,FieldNumbRequired} from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
export default {
  name: "New Funding",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  watch: {},
  computed: {},
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      valid: true,
      loaderOverlay: false,
      ppOptions: [],
      Error: [],
      FundNum:[],
      selected_Settlement: null,
      deal_num: null,
      updateTrigger: false,
      deal_no_exsites_error_status: "pending",
      temp_funding: {
        payout_partner: "",
        payout_partner_id: null,
        fund_date: "",
        lcy_amount: "",
        pp_amount: "",
        funding_number: "",
        bank_poc: "",
        coll_ccy_pay_ccy: "",
        lcy_ccy: "",
        dollar_lcy_rate: "",
        remarks: "",
        settl_id: "",
      },
    };
  },

  mounted() {
    if (this.$route.query.id) {
      this.updateTrigger = true;
      this.getSelectedFund();
    } else if (this.$route.query.settle_id) {
      this.updateTrigger = false;
      this.getSelectedSettDtl(this.$route.query.settle_id);
    }
    this.getParametersByCode("PPT");
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.temp_funding.fund_id) {
          console.log("details");
          this.updateFunding();
        } else {
          console.log("else");
          this.postFunding();
        }
      }
    },
    async getSelectedSettDtl(id) {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getSelectedFundSettDeal(id);
        console.log(responseData, "getSelectedSettDtl");
        if (responseData && responseData.data.status_code == 200) {
          this.selected_Settlement = responseData.data.data[0];
          this.temp_funding.fund_date = this.selected_Settlement?.purchase_date;
          this.temp_funding.settl_id = this.selected_Settlement?.settl_id;
          this.temp_funding.deal_no = this.selected_Settlement?.deal_no;
          this.stoploader();
        } else {
          this.loaderOverlay = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },

    async getSelectedFund() {
      const routerDataItem = this.$route.query.id;
      console.log("routerDataItem", routerDataItem);
      if (routerDataItem) {
        this.loaderOverlay = true;
        try {
          const responseData = await treasuryService.getSelectedPreFund(routerDataItem);
          console.log(responseData, "response");
          if (responseData && responseData.data.status_code == 200) {
            this.temp_funding = responseData.data.data[0];
            this.getSelectedSettDtl(this.temp_funding.settl_id);
            this.formatDateFields();
            this.stoploader();
          } else {
            this.loaderOverlay = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (err) {
          console.log(err);
          this.loaderOverlay = false;
          this.showAlertError("Fetched data Failed: Something went wrong");
        }
      }
    },
    onChangePPoptions(eve) {
        console.log(eve);
        this.ppOptions.find(
        (ele) => {
          if(ele.value === eve){
            this.temp_settlement.payout_partner_id = ele.value_code
          }
        }
      )
     
    },
    changingValue() {
      // if (this.temp_funding.lcy_amount) {
      //   this.temp_funding.remarks =
      //     "Funding to " +
      //     this.temp_funding.payout_partner +
      //     "USD " +
      //     this.temp_funding.lcy_amount;
      // }
      // console.log(this.selected_Settlement.settle_balance);

      if (this.selected_Settlement.settle_balance >= this.temp_funding.lcy_amount) {
        var temp_pp_amount =
          this.temp_funding.lcy_amount * this.temp_funding.dollar_lcy_rate;
        this.temp_funding.pp_amount = temp_pp_amount;
        this.Error = [];
      } else {
        this.Error.push(
          "Oustanding amount " + this.selected_Settlement.settle_balance + " USD"
        );
      }

      if (this.temp_funding.lcy_amount) {
        this.temp_funding.remarks =
        "Funding to "+ this.temp_funding.payout_partner +" Buying an amount of "+ this.temp_funding.lcy_amount +" USD at an exchange rate of "+ this.temp_funding.dollar_lcy_rate +" by converting an amount of "+ this.temp_funding.pp_amount+" "+this.temp_funding.coll_ccy_pay_ccy
          // "Funding to " +
          // this.temp_funding.payout_partner +
          // "USD " +
          // this.temp_funding.lcy_amount;
      }
    },
    async getParametersByCode(code) {
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData && responseData.data.status_code == 200) {
          console.log("RMT codes", responseData.data);
          this.ppOptions = responseData.data.data.map((ele) => {
            return {
              value: ele.value,
              value_code: ele.value_code,
            };
          });
        }
        console.log("paymentmode", responseData);
      } catch (e) {
        console.log(e);
      }
    },

    async CheckValidity() {
      try {
        const responseData = await treasuryService.checkValidity(
          this.temp_funding.funding_number
        );
        if (responseData && responseData.data.status_code == 200) {
          this.FundNum =[]
          } else {
            this.FundNum.push(responseData.data.message);
          }
        console.log(responseData);
      } catch (e) {
        console.log(e);
        this.FundNum =[];
      }
    },
    getRequest() {
      const req = this.temp_funding;
      for (const key of Object.keys(req)) {
        if (
          key === "deal_date" ||
          key === "purchase_date" ||
          key === "updated_date" ||
          key === "approved_aate" ||
          key === "authorized_date"
        ) {
          if (req[key]) {
            req[key] = new Date(req[key]);
          }
        }
      }
      return req;
    },
    formatDateFields() {
      if (this.temp_funding && this.temp_funding.purchase_date)
        this.temp_funding.purchase_date = this.temp_funding.purchase_date.slice(0, 10);
      if (this.temp_funding && this.temp_funding.created_date)
        this.temp_funding.created_date = this.temp_funding.created_date.slice(0, 10);
      if (this.temp_funding && this.temp_funding.modified_date)
        this.temp_funding.modified_date = this.temp_funding.modified_date.slice(0, 10);
      if (this.temp_funding && this.temp_funding.fund_date)
        this.temp_funding.fund_date = this.temp_funding.fund_date.slice(0, 10);
    },

    async updateFunding() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.updateFunds(
          this.temp_funding.fund_id,
          this.temp_funding
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          setTimeout(
            () =>
              this.$router.push({
                name: "Funding",
                query: { settle_id: responseData.data.data[0].settl_id },
              }),
            300
          );
        } else {
          this.loaderOverlay = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("Update", responseData);
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
        this.showAlertError("Invalid credentials provided in the request!");
      }
    },
    async postFunding() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.addFunding(this.temp_funding);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          setTimeout(
            () =>
              this.$router.push({
                name: "Funding",
                query: { settle_id: responseData.data.data[0].settl_id },
              }),
            300
          );
        } else {
          this.loaderOverlay = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("Save", responseData);
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
        this.showAlertError("Invalid credentials provided in the request!");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.required:after {
  content: " *";
  color: red;
}
</style>
